import { mapMaterialSubCategoryTypes, MaterialSubCategoryType } from "./MaterialSubCategoryType";

export interface MaterialCategoryType {
    id: number;
    category_name: string | null;
    path: string | null;
    for: 'Area' | 'Volume' | 'Non';
    status: 1 | 0;
    created_by: number | null;
    material_sub_category: MaterialSubCategoryType[];
}

// to single object maping
export const mapMaterialCategoryType = (data: any): MaterialCategoryType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const materialCategoryType: MaterialCategoryType = {
        id: data.id,
        category_name: data.category_name || null,
        path: data.path || null,
        for: data.for,
        status: data.status,
        created_by: data.created_by || null,
        material_sub_category: mapMaterialSubCategoryTypes(data.material_sub_category),
    }

    return materialCategoryType;
}

// maping list objects
export const mapMaterialCategoryTypes = (data: any[]): MaterialCategoryType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapMaterialCategoryType);
}